<div class="color-picker-field" [class.color-picker-field--compact]="props.compact">
  <!--
    Compact: ONE control. The swatch sits inside the field's own border and is the picker
    trigger, so there is no second square to explain and the hex box only has to be as
    wide as a hex value. The text input stays editable for anyone typing or pasting a
    value. (CHAT-995)
  -->
  <div class="color-input-wrapper">
    <!--
      A native <button>, not a div with role="button". It gets Enter/Space activation and
      real disabled semantics from the platform, where the div needed hand-written key
      handlers that only synthesised a click — and it could still be tabbed to while
      disabled. Raised in review on PR #338. (CHAT-995)
    -->
    <button
      *ngIf="props.compact"
      type="button"
      class="color-swatch-trigger"
      [disabled]="!!props.disabled"
      [attr.aria-label]="'Choose ' + (props.label || 'color')"
      [style.background-color]="formControl.value"
      [colorPicker]="formControl.value"
      [cpPosition]="props.colorPickerPosition"
      [cpOutputFormat]="props.colorPickerOutputFormat"
      [cpAlphaChannel]="props.colorPickerAlphaChannel"
      [cpDisabled]="!!props.disabled"
      (colorPickerChange)="onColorChange($event)"
      [cpDialogDisplay]="'popup'"
      title="Click to open color picker"></button>

    <input
      #colorPickerInput
      type="text"
      [formControl]="formControl"
      class="form-control color-input"
      [class.is-invalid]="showError"
      [formlyAttributes]="field"
      [(colorPicker)]="formControl.value"
      [cpPosition]="props.colorPickerPosition"
      [cpOutputFormat]="props.colorPickerOutputFormat"
      [cpAlphaChannel]="props.colorPickerAlphaChannel"
      (colorPickerChange)="onColorChange($event)"
      [ngStyle]="props.compact ? {} : { 'border-left-color': formControl.value, 'border-left-width': '4px' }" />

    <div
      *ngIf="props.showPreview && !props.compact"
      class="color-preview"
      [style.background-color]="formControl.value"
      [colorPicker]="formControl.value"
      [cpPosition]="props.colorPickerPosition"
      [cpOutputFormat]="props.colorPickerOutputFormat"
      [cpAlphaChannel]="props.colorPickerAlphaChannel"
      (colorPickerChange)="onColorChange($event)"
      [cpDialogDisplay]="'popup'"
      title="Click to open color picker"></div>
  </div>
</div>
